var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#495057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.917 2.333v9.333m0 0L7.583 9.333m2.334 2.333 2.333-2.333m-8.167 2.333V2.333m0 0L1.75 4.666m2.333-2.333 2.334 2.333"
  })));
};
export default SvgSort;